// функция предназначена для проверки соотвествия входящей даты с сегодняшней

export function isToday(date: string): boolean {
  const now = new Date();
  const formattedDate = new Date(date);

  return now.toDateString() === formattedDate.toDateString();
}
